import React, { ReactElement } from 'react';
import Box from '../../components/Box/Box';
import Icon from '../../components/Icon/Icon';
import { SuccessBadge } from '../../components/Badge';
import getComponentClassNames from '../../utils/className/getComponentClassNames';

const classNames = getComponentClassNames(['CategoryMenuBarItem'], ['link']);

type TCategoryMenuBarItemProps = {
  label: string;
  href: string;
  icon: number | string;
  children?: ReactElement;
  className?: string;
  attr?: {};
  badgeLabel?: string;
};

const CategoryMenuBarItem = ({ href, label, icon, attr, badgeLabel, ...rest }: TCategoryMenuBarItemProps) => (
  <Box {...rest} as="div" parent="CategoryMenuBar" name="Item">
    <a className={classNames.link} href={href} {...attr}>
      <Icon name={icon.toString()} />
      {label}
      {Boolean(badgeLabel) && <SuccessBadge utilities={['marginLeftXxxs']}>{badgeLabel}</SuccessBadge>}
    </a>
  </Box>
);

export default CategoryMenuBarItem;
